import { createContext, useContext, useState, useRef } from "react";
import axios from "axios";

const OptionContext = createContext(null);
const INDEX_MAP = {
  NIFTY: 13,
  BANKNIFTY: 25,
  FINNIFTY: 27,
  MIDCPNIFTY: 442,
  NIFTYIT: 26,
  NIFTYAUTO: 29,
  NIFTYPHARMA: 28,
  NIFTYMETAL: 30,
  NIFTYFMCG: 33,
  NIFTYREALTY: 38,
  NIFTYMEDIA: 32,
  NIFTYENERGY: 315,
};

// export const OptionProvider = ({ children }) => {
//   const [meta, setMeta] = useState(null);
//   const [expiries, setExpiries] = useState([]);
//   const [selectedExpiry, setSelectedExpiry] = useState(null);
//   const [optionData, setOptionData] = useState(null);
//   const [pcr, setPcr] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const BASE_URL = process.env.REACT_APP_API_BASE_URL;

//   // ---------- PCR ----------
//   const calculatePCR = (optionChainData) => {
//     let ceOI = 0;
//     let peOI = 0;

//     const oc = optionChainData?.data?.oc;
//     if (!oc) return null;

//     for (const strike in oc) {
//       ceOI += oc[strike]?.ce?.oi || 0;
//       peOI += oc[strike]?.pe?.oi || 0;
//     }

//     return {
//       value: ceOI === 0 ? 0 : (peOI / ceOI).toFixed(2),
//       totalCallOI: ceOI,
//       totalPutOI: peOI,
//     };
//   };

//   // ---------- FETCH OPTION CHAIN ----------
//   const fetchOptionChain = async (UnderlyingScrip, expiry) => {
//     // const res = await axios.post("http://localhost:8000/api/optionchain", {
//     const res = await axios.post(`${BASE_URL}/api/optionchain`, {
//       UnderlyingScrip,
//       UnderlyingSeg: "NSE_EQ",
//       Expiry: expiry,
//     });

//     setOptionData(res.data);
//     setPcr(calculatePCR(res.data));
//   };

//   // ---------- MAIN ENTRY ----------
//   const fetchBySymbol = async (symbol) => {
//     if (!symbol) return;

//     try {
//       setLoading(true);
//       setError(null);

//       // 1️⃣ Resolve symbol → security id
//       const metaRes = await axios.get(`${BASE_URL}/api/optionSymbol/${symbol}`);
//       setMeta(metaRes.data);

//       const UnderlyingScrip = metaRes.data.underlyingId;

//       // 2️⃣ Fetch expiry dates
//       const expiryRes = await axios.post(
//         `${BASE_URL}/api/optionchain/expirylist`,
//         {
//           UnderlyingScrip,
//           UnderlyingSeg: "NSE_EQ",
//         }
//       );

//       const expiryList = expiryRes.data?.data || [];
//       setExpiries(expiryList);

//       if (!expiryList.length) throw new Error("No expiries found");

//       // 3️⃣ Auto-select first expiry
//       const firstExpiry = expiryList[0];
//       setSelectedExpiry(firstExpiry);

//       // 4️⃣ Fetch option chain for selected expiry
//       await fetchOptionChain(UnderlyingScrip, firstExpiry);
//     } catch (err) {
//       setError(err.response?.data || err.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ---------- CHANGE EXPIRY ----------
//   const setExpiry = async (expiry) => {
//     if (!meta || !expiry) return;

//     setSelectedExpiry(expiry);
//     await fetchOptionChain(meta.underlyingId, expiry);
//   };

//   return (
//     <OptionContext.Provider
//       value={{
//         meta,
//         expiries,
//         selectedExpiry,
//         optionData,
//         pcr,
//         loading,
//         error,
//         fetchBySymbol,
//         setExpiry,
//       }}
//     >
//       {children}
//     </OptionContext.Provider>
//   );
// };

export const OptionProvider = ({ children }) => {
  const [meta, setMeta] = useState(null);
  const [expiries, setExpiries] = useState([]);
  const [selectedExpiry, setSelectedExpiry] = useState(null);
  const [optionData, setOptionData] = useState(null);
  const [pcr, setPcr] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const latestRequestIdRef = useRef(0);
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  // const BASE_URL = "http://localhost:8000";
  // ---------- PCR ----------
  // const calculatePCR = (optionChainData) => {
  //   let ceOI = 0;
  //   let peOI = 0;

  //   const oc = optionChainData?.data?.oc;
  //   if (!oc) return null;

  //   for (const strike in oc) {
  //     ceOI += oc[strike]?.ce?.oi || 0;
  //     peOI += oc[strike]?.pe?.oi || 0;
  //   }

  //   return {
  //     value: ceOI === 0 ? 0 : (peOI / ceOI).toFixed(2),
  //     totalCallOI: ceOI,
  //     totalPutOI: peOI,
  //   };
  // };
  // const calculatePCR = (optionChainData) => {
  //   let totalCallOI = 0;
  //   let totalPutOI = 0;
  //   let totalCallOIChange = 0;
  //   let totalPutOIChange = 0;

  //   const oc = optionChainData?.data?.oc;
  //   if (!oc) return null;

  //   for (const strike in oc) {
  //     const ce = oc[strike]?.ce;
  //     const pe = oc[strike]?.pe;

  //     if (ce) {
  //       totalCallOI += ce.oi || 0;
  //       totalCallOIChange +=
  //         ce.previous_oi != null ? ce.oi - ce.previous_oi : 0;
  //     }

  //     if (pe) {
  //       totalPutOI += pe.oi || 0;
  //       totalPutOIChange += pe.previous_oi != null ? pe.oi - pe.previous_oi : 0;
  //     }
  //   }

  //   const pcrValue =
  //     totalCallOI === 0 ? 0 : +(totalPutOI / totalCallOI).toFixed(2);

  //   // 🔹 COI Strength %
  //   const coiStrength =
  //     totalPutOI + totalCallOI === 0
  //       ? 0
  //       : +(
  //           ((totalPutOI - totalCallOI) / (totalPutOI + totalCallOI)) *
  //           100
  //         ).toFixed(2);

  //   // 🔹 PCR Sentiment
  //   let sentiment = "Neutral";
  //   if (pcrValue < 0.7) sentiment = "Bearish";
  //   else if (pcrValue > 1.0 && pcrValue <= 1.3) sentiment = "Bullish";
  //   else if (pcrValue > 1.3) sentiment = "Overly Bullish";

  //   return {
  //     value: pcrValue,
  //     totalCallOI,
  //     totalPutOI,
  //     totalCallOIChange,
  //     totalPutOIChange,
  //     coiStrength,
  //     sentiment,
  //   };
  // };
  // const calculatePCR = (optionChainData) => {
  //   let totalCallOI = 0;
  //   let totalPutOI = 0;

  //   let callOIChange = 0;
  //   let putOIChange = 0;

  //   const oc = optionChainData?.data?.oc;
  //   if (!oc) return null;

  //   for (const strike in oc) {
  //     const ce = oc[strike]?.ce;
  //     const pe = oc[strike]?.pe;

  //     /* ---------- TOTAL OI ---------- */
  //     totalCallOI += ce?.oi || 0;
  //     totalPutOI += pe?.oi || 0;

  //     /* ---------- CHANGE IN OI ---------- */
  //     if (ce?.previous_oi != null) {
  //       callOIChange += ce.oi - ce.previous_oi;
  //     }

  //     if (pe?.previous_oi != null) {
  //       putOIChange += pe.oi - pe.previous_oi;
  //     }
  //   }

  //   /* ---------- TOTAL PCR ---------- */
  //   const pcr = totalCallOI === 0 ? 0 : +(totalPutOI / totalCallOI).toFixed(2);

  //   /* ---------- COI PCR ---------- */
  //   const coiPCR =
  //     callOIChange === 0 ? 0 : +(putOIChange / callOIChange).toFixed(2);

  //   /* ---------- COI STRENGTH % ---------- */
  //   const coiStrength =
  //     Math.abs(callOIChange) + Math.abs(putOIChange) === 0
  //       ? 0
  //       : +(
  //           ((putOIChange - callOIChange) /
  //             (Math.abs(putOIChange) + Math.abs(callOIChange))) *
  //           100
  //         ).toFixed(2);

  //   /* ---------- OI STRENGTH % ---------- */
  //   const denominator = Math.abs(putOIChange) + Math.abs(callOIChange);

  //   const oiStrength =
  //     denominator === 0
  //       ? 0
  //       : +(((putOIChange - callOIChange) / denominator) * 100).toFixed(2);

  //   /* ---------- COI SENTIMENT ---------- */
  //   let coiSentiment = "Neutral";
  //   if (coiStrength > 30) coiSentiment = "Bullish";
  //   if (coiStrength < -30) coiSentiment = "Bearish";

  //   return {
  //     /* 🔹 Total PCR */
  //     value: pcr,
  //     totalCallOI,
  //     totalPutOI,

  //     /* 🔹 Change in OI */
  //     callOIChange,
  //     putOIChange,

  //     /* 🔹 COI metrics */
  //     coiPCR,
  //     coiStrength,
  //     coiSentiment,
  //     oiStrength,
  //   };
  // };
  const calculatePCR = (optionChainData) => {
    let totalCallOI = 0;
    let totalPutOI = 0;

    let callOIChange = 0;
    let putOIChange = 0;

    const oc = optionChainData?.data?.oc;
    if (!oc) return null;

    /* ================= LOOP THROUGH STRIKES ================= */
    for (const strike in oc) {
      const ce = oc[strike]?.ce;
      const pe = oc[strike]?.pe;

      /* ---------- TOTAL OI ---------- */
      totalCallOI += ce?.oi || 0;
      totalPutOI += pe?.oi || 0;

      /* ---------- CHANGE IN OI ---------- */
      if (ce?.previous_oi != null) {
        callOIChange += ce.oi - ce.previous_oi;
      }

      if (pe?.previous_oi != null) {
        putOIChange += pe.oi - pe.previous_oi;
      }
    }

    /* ================= TOTAL PCR ================= */
    const pcr = totalCallOI === 0 ? 0 : +(totalPutOI / totalCallOI).toFixed(2);

    /* ================= OI STRENGTH % =================
     Formula:
     ((PE OI - CE OI) / (|PE OI| + |CE OI|)) * 100
  */
    const oiStrengthDenominator = Math.abs(totalPutOI) + Math.abs(totalCallOI);

    const oiStrength =
      oiStrengthDenominator === 0
        ? 0
        : +(((totalPutOI - totalCallOI) / oiStrengthDenominator) * 100).toFixed(
            2,
          );

    /* ================= COI PCR ================= */
    const coiPCR =
      callOIChange === 0 ? 0 : +(putOIChange / callOIChange).toFixed(2);

    /* ================= COI STRENGTH % =================
     Formula:
     ((PE COI - CE COI) / (|PE COI| + |CE COI|)) * 100
  */
    const coiStrengthDenominator =
      Math.abs(putOIChange) + Math.abs(callOIChange);

    const coiStrength =
      coiStrengthDenominator === 0
        ? 0
        : +(
            ((putOIChange - callOIChange) / coiStrengthDenominator) *
            100
          ).toFixed(2);

    /* ================= COI SENTIMENT ================= */
    let coiSentiment = "Neutral";
    if (coiStrength > 60) coiSentiment = "Bullish";
    if (coiStrength < -60) coiSentiment = "Bearish";

    /* ================= RETURN ================= */
    return {
      /* 🔹 PCR */
      value: pcr,

      /* 🔹 Total OI */
      totalCallOI,
      totalPutOI,

      /* 🔹 OI Strength */
      oiStrength,

      /* 🔹 OI Change */
      callOIChange,
      putOIChange,

      /* 🔹 COI Metrics */
      coiPCR,
      coiStrength,
      coiSentiment,
    };
  };

  // ---------- FETCH OPTION CHAIN ----------

  //old without error handling
  // const fetchOptionChain = async (UnderlyingScrip, UnderlyingSeg, expiry) => {
  //   const res = await axios.post(`${BASE_URL}/api/optionchain`, {
  //     UnderlyingScrip,
  //     UnderlyingSeg,
  //     Expiry: expiry,
  //   });

  //   setOptionData(res.data);
  //   setPcr(calculatePCR(res.data));
  // };
  // AFTER
  // const fetchOptionChain = async (UnderlyingScrip, UnderlyingSeg, expiry) => {
  //   try {
  //     const res = await axios.post(`${BASE_URL}/api/optionchain`, {
  //       UnderlyingScrip,
  //       UnderlyingSeg,
  //       Expiry: expiry,
  //     });

  //     if (!res.data?.data?.oc) {
  //       setError("Option chain data is empty or malformed");
  //       setOptionData(null);
  //       setPcr(null);
  //       return;
  //     }

  //     setOptionData(res.data);
  //     setPcr(calculatePCR(res.data));
  //     setError(null);
  //   } catch (err) {
  //     console.error("Option chain fetch failed:", err);
  //     setError("Failed to load option chain");
  //     setOptionData(null);
  //     setPcr(null);
  //   }
  // };

  const fetchOptionChain = async ({
    underlyingScrip,
    underlyingSeg,
    expiry,
    requestId,
  }) => {
    const res = await axios.post(`${BASE_URL}/api/optionchain`, {
      UnderlyingScrip: underlyingScrip,
      UnderlyingSeg: underlyingSeg,
      Expiry: expiry,
    });

    if (requestId != null && requestId !== latestRequestIdRef.current) {
      return;
    }

    const oc = res.data?.data?.oc;

    if (!oc || Object.keys(oc).length === 0) {
      throw new Error("Option chain data is empty");
    }

    setOptionData(res.data);
    setPcr(calculatePCR(res.data));
    setError(null);
  };
  // ---------- STOCK FLOW ----------

  //old code
  // const fetchBySymbol = async (symbol) => {
  //   if (!symbol) return;
  //   resetOptionState();
  //   try {
  //     setLoading(true);
  //     setError(null);

  //     const metaRes = await axios.get(`${BASE_URL}/api/optionSymbol/${symbol}`);

  //     const resolvedMeta = {
  //       ...metaRes.data,
  //       segment: "NSE_EQ",
  //       type: "STOCK",
  //     };

  //     setMeta(resolvedMeta);

  //     const expiryRes = await axios.post(
  //       `${BASE_URL}/api/optionchain/expirylist`,
  //       {
  //         UnderlyingScrip: resolvedMeta.underlyingId,
  //         UnderlyingSeg: "NSE_EQ",
  //       },
  //     );

  //     const expiryList = expiryRes.data?.data || [];
  //     if (!expiryList.length) {
  //       resetOptionState();
  //       setError("Option chain not available for this stock");
  //       return;
  //     }

  //     setExpiries(expiryList);

  //     // if (!expiryList.length) throw new Error("No expiries found");

  //     const firstExpiry = expiryList[0];
  //     setSelectedExpiry(firstExpiry);

  //     await fetchOptionChain(resolvedMeta.underlyingId, "NSE_EQ", firstExpiry);
  //   } catch (err) {
  //     resetOptionState(); // 🔥 Prevent stale data
  //     setError(" Please enter correct Stock Symbol");
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  const fetchBySymbol = async (symbolOrPayload, providedSecurityId = null) => {
    const symbol =
      typeof symbolOrPayload === "object"
        ? symbolOrPayload?.symbol
        : symbolOrPayload;

    const securityId =
      typeof symbolOrPayload === "object"
        ? symbolOrPayload?.securityId
        : providedSecurityId;

    if (!symbol) return;

    const formattedSymbol = symbol.trim().toUpperCase();
    const requestId = ++latestRequestIdRef.current;

    resetOptionState();
    setLoading(true);
    setError(null);

    try {
      let underlyingId = securityId;

      /*
      Fallback for existing pages that only send symbol.

      Example:
      fetchBySymbol("RELIANCE")
    */
      if (!underlyingId) {
        const metaRes = await axios.get(
          `${BASE_URL}/api/optionSymbol/${formattedSymbol}`,
        );

        if (requestId !== latestRequestIdRef.current) return;

        underlyingId =
          metaRes.data?.underlyingId ||
          metaRes.data?.securityId ||
          metaRes.data?.security_id;
      }

      if (!underlyingId) {
        throw new Error("Underlying security ID missing");
      }

      const resolvedMeta = {
        symbol: formattedSymbol,
        underlyingId,
        securityId: underlyingId,
        segment: "NSE_EQ",
        type: "STOCK",
      };

      setMeta(resolvedMeta);

      const expiryRes = await axios.post(
        `${BASE_URL}/api/optionchain/expirylist`,
        {
          UnderlyingScrip: underlyingId,
          UnderlyingSeg: "NSE_EQ",
        },
      );

      if (requestId !== latestRequestIdRef.current) return;

      const expiryList = expiryRes.data?.data || [];

      if (!expiryList.length) {
        setOptionData(null);
        setPcr(null);
        setError("Option chain not available for this stock");
        return;
      }

      const firstExpiry = expiryList[0];

      setExpiries(expiryList);
      setSelectedExpiry(firstExpiry);

      await fetchOptionChain({
        underlyingScrip: underlyingId,
        underlyingSeg: "NSE_EQ",
        expiry: firstExpiry,
        requestId,
      });
    } catch (err) {
      if (requestId !== latestRequestIdRef.current) return;

      console.error("fetchBySymbol failed:", {
        symbol: formattedSymbol,
        securityId,
        status: err.response?.status,
        response: err.response?.data,
        message: err.message,
      });

      setOptionData(null);
      setPcr(null);
      setExpiries([]);
      setSelectedExpiry(null);

      if (err.response?.status === 404) {
        setError("Stock symbol not found");
      } else if (err.message === "Option chain data is empty") {
        setError("Option chain is currently unavailable for this stock");
      } else if (err.message === "Underlying security ID missing") {
        setError("Security ID is missing for this stock");
      } else {
        setError(
          err.response?.data?.message ||
            err.response?.data?.error ||
            "Unable to load option-chain data",
        );
      }
    } finally {
      if (requestId === latestRequestIdRef.current) {
        setLoading(false);
      }
    }
  };
  // const fetchBySymbol = async (symbol) => {
  //   if (!symbol) return;

  //   const formattedSymbol = symbol.trim().toUpperCase();
  //   const requestId = ++latestRequestIdRef.current;

  //   resetOptionState();
  //   setLoading(true);
  //   setError(null);

  //   try {
  //     const metaRes = await axios.get(
  //       `${BASE_URL}/api/optionSymbol/${formattedSymbol}`,
  //     );

  //     if (requestId !== latestRequestIdRef.current) return;

  //     const resolvedMeta = {
  //       ...metaRes.data,
  //       symbol: formattedSymbol,
  //       segment: "NSE_EQ",
  //       type: "STOCK",
  //     };

  //     if (!resolvedMeta?.underlyingId) {
  //       throw new Error("Underlying security ID missing");
  //     }

  //     setMeta(resolvedMeta);

  //     const expiryRes = await axios.post(
  //       `${BASE_URL}/api/optionchain/expirylist`,
  //       {
  //         UnderlyingScrip: resolvedMeta.underlyingId,
  //         UnderlyingSeg: "NSE_EQ",
  //       },
  //     );

  //     if (requestId !== latestRequestIdRef.current) return;

  //     const expiryList = expiryRes.data?.data || [];

  //     if (!expiryList.length) {
  //       setError("Option chain not available for this stock");
  //       return;
  //     }

  //     const firstExpiry = expiryList[0];

  //     setExpiries(expiryList);
  //     setSelectedExpiry(firstExpiry);

  //     await fetchOptionChain({
  //       underlyingScrip: resolvedMeta.underlyingId,
  //       underlyingSeg: "NSE_EQ",
  //       expiry: firstExpiry,
  //       requestId,
  //     });
  //     // } catch (err) {
  //     //   if (requestId !== latestRequestIdRef.current) return;

  //     //   console.error("Stock option fetch failed:", err);
  //     //   setError(
  //     //     err.response?.data?.message ||
  //     //       err.response?.data?.error ||
  //     //       "Option chain not available for this stock",
  //     //   );
  //     // }
  //   } catch (err) {
  //     if (requestId !== latestRequestIdRef.current) return;

  //     console.error("fetchBySymbol failed:", {
  //       symbol: formattedSymbol,
  //       status: err.response?.status,
  //       response: err.response?.data,
  //       message: err.message,
  //     });

  //     setOptionData(null);
  //     setPcr(null);

  //     if (err.response?.status === 404) {
  //       setError("Stock symbol not found");
  //     } else if (err.message === "Option chain data is empty") {
  //       setError("Option chain is currently unavailable for this stock");
  //     } else {
  //       setError(
  //         err.response?.data?.message ||
  //           err.response?.data?.error ||
  //           "Unable to load option-chain data",
  //       );
  //     }
  //   } finally {
  //     if (requestId === latestRequestIdRef.current) {
  //       setLoading(false);
  //     }
  //   }
  // };
  // const fetchBySymbol = async (symbol) => {
  //   if (!symbol) return;

  //   const formattedSymbol = symbol.trim().toUpperCase();
  //   const requestId = ++latestRequestIdRef.current;

  //   resetOptionState();
  //   setLoading(true);
  //   setError(null);

  //   try {
  //     // Use search API to resolve the security ID (skip /optionSymbol)
  //     const searchRes = await axios.get(`${BASE_URL}/api/search-stocks`, {
  //       params: { q: formattedSymbol },
  //     });

  //     if (requestId !== latestRequestIdRef.current) return;

  //     const match = searchRes.data?.find(
  //       (item) => item.symbol?.toUpperCase() === formattedSymbol,
  //     );

  //     if (!match || !match.security_id) {
  //       setError("Stock symbol not found");
  //       return;
  //     }

  //     const resolvedMeta = {
  //       underlyingId: match.security_id, // adjust field name to match your search API response
  //       symbol: formattedSymbol,
  //       segment: "NSE_EQ",
  //       type: "STOCK",
  //     };

  //     setMeta(resolvedMeta);

  //     const expiryRes = await axios.post(
  //       `${BASE_URL}/api/optionchain/expirylist`,
  //       {
  //         UnderlyingScrip: resolvedMeta.underlyingId,
  //         UnderlyingSeg: "NSE_EQ",
  //       },
  //     );

  //     if (requestId !== latestRequestIdRef.current) return;

  //     const expiryList = expiryRes.data?.data || [];

  //     if (!expiryList.length) {
  //       setError("Option chain not available for this stock");
  //       return;
  //     }

  //     const firstExpiry = expiryList[0];
  //     setExpiries(expiryList);
  //     setSelectedExpiry(firstExpiry);

  //     await fetchOptionChain({
  //       underlyingScrip: resolvedMeta.underlyingId,
  //       underlyingSeg: "NSE_EQ",
  //       expiry: firstExpiry,
  //       requestId,
  //     });
  //   } catch (err) {
  //     if (requestId !== latestRequestIdRef.current) return;

  //     console.error("fetchBySymbol failed:", err);
  //     setOptionData(null);
  //     setPcr(null);
  //     setError("Unable to load option-chain data");
  //   } finally {
  //     if (requestId === latestRequestIdRef.current) {
  //       setLoading(false);
  //     }
  //   }
  // };

  // ---------- INDEX FLOW ----------
  //old value
  // const fetchByIndex = async (indexSymbol) => {
  //   const securityId = INDEX_MAP[indexSymbol];
  //   if (!securityId) return;
  //   resetOptionState();
  //   try {
  //     setLoading(true);
  //     setError(null);

  //     const resolvedMeta = {
  //       symbol: indexSymbol,
  //       underlyingId: securityId,
  //       segment: "IDX_I",
  //       type: "INDEX",
  //     };

  //     setMeta(resolvedMeta);

  //     const expiryRes = await axios.post(
  //       `${BASE_URL}/api/optionchain/expirylist`,
  //       {
  //         UnderlyingScrip: securityId,
  //         UnderlyingSeg: "IDX_I",
  //       },
  //     );

  //     const expiryList = expiryRes.data?.data || [];

  //     if (!expiryList.length) {
  //       resetOptionState();
  //       setError("No expiries found");
  //       return;
  //     }
  //     setExpiries(expiryList);

  //     // if (!expiryList.length) throw new Error("No expiries found");

  //     const firstExpiry = expiryList[0];
  //     setSelectedExpiry(firstExpiry);

  //     await fetchOptionChain(securityId, "IDX_I", firstExpiry);
  //   } catch (err) {
  //     setError(" Please enter correct Index");
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  const fetchByIndex = async (indexSymbol) => {
    if (!indexSymbol) return;

    const formattedIndex = indexSymbol.trim().toUpperCase();
    const securityId = INDEX_MAP[formattedIndex];

    if (!securityId) {
      setError("Index is not supported");
      return;
    }

    const requestId = ++latestRequestIdRef.current;

    resetOptionState();
    setLoading(true);
    setError(null);

    try {
      const resolvedMeta = {
        symbol: formattedIndex,
        underlyingId: securityId,
        segment: "IDX_I",
        type: "INDEX",
      };

      setMeta(resolvedMeta);

      const expiryRes = await axios.post(
        `${BASE_URL}/api/optionchain/expirylist`,
        {
          UnderlyingScrip: securityId,
          UnderlyingSeg: "IDX_I",
        },
      );

      if (requestId !== latestRequestIdRef.current) {
        return;
      }

      const expiryList = expiryRes.data?.data || [];

      if (!expiryList.length) {
        setError("No expiries found for this index");
        return;
      }

      const firstExpiry = expiryList[0];

      setExpiries(expiryList);
      setSelectedExpiry(firstExpiry);

      await fetchOptionChain({
        underlyingScrip: securityId,
        underlyingSeg: "IDX_I",
        expiry: firstExpiry,
        requestId,
      });
    } catch (err) {
      if (requestId !== latestRequestIdRef.current) {
        return;
      }

      console.error("fetchByIndex failed:", {
        index: formattedIndex,
        status: err.response?.status,
        response: err.response?.data,
        message: err.message,
      });

      setOptionData(null);
      setPcr(null);

      if (err.message === "Option chain data is empty") {
        setError("Option chain is currently unavailable for this index");
      } else {
        setError(
          err.response?.data?.message ||
            err.response?.data?.error ||
            "Unable to load index option-chain data",
        );
      }
    } finally {
      if (requestId === latestRequestIdRef.current) {
        setLoading(false);
      }
    }
  };

  // const fetchByAsset = async ({ symbol, type }) => {
  //   if (!symbol || !type) return;

  //   const formattedType = type.toUpperCase();

  //   if (formattedType === "INDEX") {
  //     return fetchByIndex(symbol);
  //   }

  //   return fetchBySymbol(symbol);
  // };

  // ---------- CHANGE EXPIRY ----------

  //old code
  // const setExpiry = async (expiry) => {
  //   if (!meta || !expiry) return;

  //   setSelectedExpiry(expiry);
  //   await fetchOptionChain(meta.underlyingId, meta.segment, expiry);
  // };
  // new code
  // const setExpiry = async (expiry) => {
  //   if (!meta || !expiry) return;

  //   try {
  //     setLoading(true);
  //     setError(null);
  //     setSelectedExpiry(expiry);
  //     await fetchOptionChain(meta.underlyingId, meta.segment, expiry);
  //   } catch (err) {
  //     setError("Failed to load option chain for selected expiry");
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  const fetchByAsset = async ({ symbol, type }) => {
    if (!symbol || !type) return;

    const formattedType = type.toUpperCase();

    if (formattedType === "INDEX") {
      return fetchByIndex(symbol);
    }

    return fetchBySymbol(symbol);
  };
  const setExpiry = async (expiry) => {
    if (!expiry) return;

    const currentMeta = meta;

    if (!currentMeta?.underlyingId || !currentMeta?.segment) {
      setError("Option metadata is not ready");
      return;
    }

    const requestId = ++latestRequestIdRef.current;

    try {
      setLoading(true);
      setError(null);
      setSelectedExpiry(expiry);

      await fetchOptionChain({
        underlyingScrip: currentMeta.underlyingId,
        underlyingSeg: currentMeta.segment,
        expiry,
        requestId,
      });
    } catch (err) {
      if (requestId !== latestRequestIdRef.current) {
        return;
      }

      console.error("setExpiry failed:", {
        symbol: currentMeta.symbol,
        expiry,
        status: err.response?.status,
        response: err.response?.data,
        message: err.message,
      });

      if (err.message === "Option chain data is empty") {
        setError("No option-chain data found for this expiry");
      } else {
        setError(
          err.response?.data?.message ||
            err.response?.data?.error ||
            "Failed to load option chain for selected expiry",
        );
      }
    } finally {
      if (requestId === latestRequestIdRef.current) {
        setLoading(false);
      }
    }
  };
  const cancelCurrentRequest = () => {
    latestRequestIdRef.current += 1;
  };
  // const resetOptionState = () => {
  //   setOptionData(null);
  //   setExpiries([]);
  //   setSelectedExpiry("");
  //   setPcr(null);
  //   setMeta(null);
  // };

  // AFTER
  const resetOptionState = () => {
    setOptionData(null);
    setExpiries([]);
    setSelectedExpiry(null);
    setPcr(null);
    setMeta(null);
    setError(null); // also clear stale errors
  };
  return (
    <OptionContext.Provider
      // value={{
      //   meta,
      //   expiries,
      //   selectedExpiry,
      //   setSelectedExpiry,
      //   resetOptionState,
      //   optionData,
      //   pcr,
      //   loading,
      //   error,
      //   fetchBySymbol,
      //   fetchByIndex,
      //   setExpiry,
      //   fetchByAsset,
      // }}
      value={{
        meta,
        expiries,
        selectedExpiry,
        setSelectedExpiry,
        resetOptionState,
        cancelCurrentRequest,
        optionData,
        pcr,
        loading,
        error,
        fetchBySymbol,
        fetchByIndex,
        setExpiry,
        fetchByAsset,
      }}
    >
      {children}
    </OptionContext.Provider>
  );
};
export const useOption = () => {
  const context = useContext(OptionContext);
  if (!context) {
    throw new Error("useOption must be used inside OptionProvider");
  }
  return context;
};
